import ADPRefcodeService from "../../../services/admin/ADPRefcodeService";
import ASTInstrumentService from "../../../services/ast/ASTInstrumentService";
import ASTQrdetService from "../../../services/ast/ASTQrdetService";
import ASTQrService from "../../../services/ast/ASTQrService";

class assignmentService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async findAll(recordFilter: any): Promise<any> {
        return await ASTQrService.findAll(recordFilter);
    }

    async getGenderDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async create(item: any): Promise<any> {
        return await ASTQrService.create(item);
    }

    async findAllQRdet(qrBatchId: any): Promise<any> {
        return await ASTQrdetService.getItemsByQrBatchId(qrBatchId);
    }

    async findOneInstrumentNoAccess(instrumentId: any): Promise<any> {
        return await ASTInstrumentService.findOneNoAccess(instrumentId);
    }
    async findOneQRNoAccess(qrId: any): Promise<any> {
        return await ASTQrdetService.findOneNoAccess(qrId);
    }

    async findAllInstrumentBySN(snNo: any): Promise<any> {
        return await ASTInstrumentService.findAllInstrumentBySN({ snNo: snNo });
    }

    async findOneInstrumentBySNAndEntity(snNo: any, entity: any): Promise<any> {
        return await ASTInstrumentService.findOneInstrumentBySNAndEntity(snNo, entity);
    }


    async assign(item: any): Promise<any> {
        return await ASTQrdetService.update(item.qrId, item);
    }

    async findOneQrdet(qrId: any): Promise<any> {
        return await ASTQrdetService.getItemById(qrId);
    }
    async findOneQRByInstrumentBySN(snNo: any): Promise<any> {
        return await ASTQrdetService.findOneInstrumentBySN(snNo);
    }

    async findOneQrByInstrumentId(instrumentId: any): Promise<any> {
        return await ASTQrdetService.findOneQrByInstrumentId(instrumentId);
    }

}

export default new assignmentService();
